<script>
  export let question;
  import { fly } from 'svelte/transition';

</script>

<style>

  h1 {
    grid-column: 1;
    grid-row: 1;
  }

</style>

{#key question}
  <h1 in:fly="{{ x: 700, duration: 200 }}" out:fly="{{ x: -700, duration: 200 }}">{question}</h1>
{/key}
